import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import User from './index';
import MobileUser from './MobileUser';

const ResponsiveUser = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileUser />}
      desktop={<User />}
    />
  );
};

export default ResponsiveUser;